import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `NameRendererHost`,
  link: `NameRendererLink`,
  root: `NameRenderer`,
  stagingIcon: `NameRendererStagingIcon`,
  name: `NameRendererName`
};

export function useNameRendererStyles(styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>) {
  const { semanticColors, spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`,
            ...textOverflow
          }
        ],
        icon: [
          classNames.stagingIcon,
          {
            color: semanticColors.link,
            marginRight: spacing.s1,
            marginTop: `-3px`
          }
        ],
        link: [
          classNames.link,
          {
            ":hover, :active, :link, :visited": {
              textDecoration: `none`
            }
          }
        ],
        name: [
          classNames.name,
          {
            ...textOverflow
          }
        ]
      },
      { host: styles }
    ),
    [semanticColors, spacing, styles]
  );
}
